<select #langSelect (change)="languageChange(langSelect.value)" class="newSelectBox">
    <option *ngFor="let lang of langArr" [value]="lang.val" [attr.selected]="lang.name === selectedLang ? '' : null">
        {{lang.name}}</option>
</select>